<template>
	<div class="page">
		<full-page :options="options" ref="page">
			<div class="section" v-for="(d, index) in data">
				<div class="content">
					<div class="area" :class="{ flex_reverse: index % 2 == 1 }">
						<div class="left">
							<img :src="d.img" />
						</div>
						<div class="right">
							<div class="info">
								<div class="title">{{ d.title }}</div>
								<div class="text">{{ d.text }}</div>
								<div style="display: flex;">
									<el-button v-if="index == 0" class="download" @click="download()">下 载<br />v0.9.1</el-button>
									<el-button v-if="index == 0" class="download" @click="doc()">文档</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</full-page>
	</div>
</template>

<script>
	import NavBar from "components/NavBar.vue"
	export default {
		components: {
			NavBar,
		},
		data() {
			return {
				options: {
					sectionsColor: ["#a9b9ff", "#5e8e43", "#dbe9ff", "#ffc7ab", "#ffe5f3"],
				},
				data: [{
						img: require("../../public/img/1.png"),
						title: "RobotStudio",
						text: "结合引导式编程功能的机器人开发集成环境，让机器人编程比以往任何时候都更流畅",
					},
					{
						img: require("../../public/img/2.gif"),
						title: "参数及配置",
						text: "详细丰富的配置项，满足工业场景的精密控制",
					},
					{
						img: "http://static.highvenue.cn/RobotStudioWeb/1.gif",
						title: "仿真",
						text: "生动准确的仿真，让机器人走进课堂成为可能",
					},
					{
						img: require("../../public/img/3.gif"),
						title: "可视化编程",
						text: "摆脱传统工业机器人复杂的开发流程，只需简单拖拽即可生成机器人指令",
					},
					{
						img: require("../../public/img/6.gif"),
						title: "文本编程",
						text: "针对专业用户，内置多语言开发环境，大大加快开发灵活性与效率",
					},
				],
			}
		},
		methods: {
			download() {
				window.open("https://static.highvenue.cn/RobotStudio%20Setup%200.9.1.exe")
			},
			doc() {
				window.open("http://doc.ide.rosc.org.cn/overview/overview/")
			}
		},
	}
</script>

<style lang="scss" scoped>
	.nav {
		background: red;
	}

	.page {
		.section {
			.content {
				width: 100%;
				height: 100%;
				@include flex;

				.flex_reverse {
					flex-direction: row-reverse;
				}

				.area {
					width: 90vw;
					height: 80vh;
					@include flex;
					flex-wrap: wrap;

					img {
						width: 100%;
						transition: all 0.6s;
					}

					img:hover {
						transform: scale(1.2);
					}

					.left {
						width: 50%;
						min-width: 500px;
						@include flex;
					}

					.right {
						width: 50%;
						min-width: 500px;
						@include flex;
					}

					.info {
						@include flex;
						flex-direction: column;
						color: white;
						padding: 40px;

						.title {
							font-size: 40px;
						}

						.text {
							margin-top: 20px;
							font-size: 30px;
						}

						.download {
							width: 200px;
							color: $color-1;
							font-weight: 600;
							font-size: 20px;
							height: 60px;
							border: 1px solid white;
							margin-top: 50px;
						}
					}
				}
			}
		}
	}
</style>
